module.exports = "/assets/data/6e5ad2bb3bd53cff49ebb960da56c8c5-CR4.data.json";